import { render, staticRenderFns } from "./ShippingCompanyTable.vue?vue&type=template&id=fc42ece4&scoped=true"
import script from "./ShippingCompanyTable.vue?vue&type=script&lang=js"
export * from "./ShippingCompanyTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc42ece4",
  null
  
)

export default component.exports